import script from "./addByBrandDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./addByBrandDialog.vue?vue&type=script&lang=ts&setup=true"

import "./addByBrandDialog.vue?vue&type=style&index=0&id=3100b2c0&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3100b2c0"]])

export default __exports__